import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section columns" }
const _hoisted_2 = { class: "!flex flex-col" }
const _hoisted_3 = { class: "wrong" }
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "correct" }
const _hoisted_7 = { class: "correct" }
const _hoisted_8 = { class: "section columns mb-rem3" }
const _hoisted_9 = { class: "polaroid-frame w-lg mb-rem2" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "image-subtitle" }
const _hoisted_12 = { class: "polaroid-frame w-lg mb-rem2" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "image-subtitle" }
const _hoisted_15 = { class: "section columns" }
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "section lg:text-center" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Myobrace',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_info_panel = _resolveComponent("a-info-panel")!
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.myobrace.title'),
    cover: require('@/assets/covers/myobrace.jpg'),
    "close-button-dark": true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_info_panel, {
            icon: require('@/assets/png-icons/bulb.png'),
            class: "mb-rem2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.myobrace.infoPanelBold')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.myobrace.infoPanelBody')), 1)
            ]),
            _: 1
          }, 8, ["icon"]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.myobrace.intro')), 1),
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('articles.myobrace.wrongList'), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: String(item)
              }, _toDisplayString(item), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "max-w-rem12 mb-rem3 mt-rem1",
              src: require('@/assets/myobrace-certified.jpg'),
              alt: "myobrace-certified logo"
            }, null, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.myobrace.correctTitleBold')), 1),
            _cache[2] || (_cache[2] = _createTextVNode(": ", -1))
          ]),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('articles.myobrace.correctList'), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: String(item)
              }, _toDisplayString(item), 1))
            }), 128))
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.myobrace.resultTitleBold')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.myobrace.resultTitleSuffix')) + ": ", 1)
          ]),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('articles.myobrace.resultList'), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: String(item)
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "sm:!mt-0" }, null, -1)),
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.myobrace.clinicalTitle')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.invisalign.clinicalP')), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            src: require('@/assets/myobrace-before.jpg'),
            loading: "lazy",
            alt: ""
          }, null, 8, _hoisted_10),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('articles.myobrace.beforeTherapy')), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("img", {
            src: require('@/assets/myobrace-after.jpg'),
            loading: "lazy",
            alt: ""
          }, null, 8, _hoisted_13),
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('articles.myobrace.afterTherapy')), 1)
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.myobrace.whenTitle')), 1),
          _createElementVNode("p", null, [
            _createElementVNode("span", {
              innerHTML: _ctx.$t('articles.myobrace.whenP1')
            }, null, 8, _hoisted_17),
            _createVNode(_component_a_circular_image, {
              image: require('@/assets/photos/myobrace-child.jpg'),
              class: "mt-rem1 sm:mt-rem3"
            }, null, 8, ["image"]),
            _createElementVNode("span", {
              innerHTML: _ctx.$t('articles.myobrace.whenP2')
            }, null, 8, _hoisted_18)
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "mobile-only" }, null, -1)),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.myobrace.therapyTitle')), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('articles.myobrace.therapyP1pre')) + " ", 1),
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.myobrace.therapySixVisits')), 1),
            _cache[3] || (_cache[3] = _createTextVNode(". ", -1))
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.myobrace.therapyP2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.myobrace.therapyP3')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.myobrace.therapyP4')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.myobrace.therapyP5')), 1),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('articles.myobrace.therapyResults')
          }, null, 8, _hoisted_19)
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.myobrace.cenikPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'ortodontija')))
          }, _toDisplayString(_ctx.$t('articles.myobrace.cenikLinkText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.myobrace.cenikPost')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})